import React from "react";

export const useDetectSticky = (ref: React.RefObject<HTMLDivElement>) => {
  const [isSticky, setIsSticky] = React.useState(false);

  React.useEffect(() => {
    const currentRef = ref.current;
    const observer = new IntersectionObserver(([entry]) => setIsSticky(entry.intersectionRatio < 1), {
      threshold: [1],
    });

    if (currentRef) {
      observer.observe(currentRef);
    }

    // unmount
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [ref]);

  return isSticky;
};
